import { writable,  derived } from "svelte/store";

const createPath = () => {
  const { subscribe, set } = writable([]);

  return { subscribe, set }
}
export const path = createPath();

export const currentStep = derived(path, $path => $path[$path.length - 1]);